import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import { defineMessages } from 'react-intl';
import config from '@plone/volto/registry';

const messages = defineMessages({
  BlockWidth: {
    id: 'blockwidth',
    defaultMessage: 'Block Width',
  },
});

export const blockWidthStylingSchema = ({ schema, formData, intl }) => {
  addStyling({ schema, intl });

  schema.properties.styles.schema.properties['blockWidth:noprefix'] = {
    widget: 'blockWidth',
    title: intl.formatMessage(messages.BlockWidth),
    default: 'layout',
    filterActions: ['narrow', 'default', 'layout'],
    actions: config.blocks.widths,
  };
  schema.properties.styles.schema.fieldsets[0].fields = [
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'blockWidth:noprefix',
  ];

  return schema;
};
